import React from 'react';
import Card from './Card';
import item1 from './../../assests/kitchen/item1.png';
import item2 from './../../assests/kitchen/item2.png';
import item3 from './../../assests/kitchen/item3.png';
import item4 from './../../assests/kitchen/item4.png';
import item5 from './../../assests/kitchen/item5.png';
import item6 from './../../assests/kitchen/item6.png';

import { motion } from 'framer-motion';

export default function Index() {
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: '-100vw',
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.5,
      },
    },
  };

  // let cards = [];
  const arr = [
    item1,
    item2,
    item3,
    item4,
    item5,
    item6,
    item1,
    item2,
    item3,
    item4,
    item5,
    item6,
    item1,
    item2,
    item3,
    item4,
    item5,
    item6,
    item1,
    item2,
    item3,
    item4,
    item5,
    item6,
  ];
  const renderCards = () => {
    return arr.map((i) => {
      return <Card key={Date.now() + Math.random() * 4} img={i} />;
    });
  };
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="product"
    >
      {renderCards()}
    </motion.div>
  );
}
